import { useQuery } from 'react-query';

import { RoleEnum } from '@project/enums/role.enum';
import { AccountProfiles, Guid, ProfileInfoProps, ProfileType } from '@project/types';
import { getAccountProfiles } from '@project/services/api/admin-profiles/admin-profiles.service';

export const useAccountInfoQuery = (userId: Guid, profileType: ProfileType) => {
  return useQuery<AccountProfiles, void, ProfileInfoProps>(
    ['AdminAccountProfileData', userId],
    () => getAccountProfiles(userId),
    {
      enabled: !!userId,
      select: (result) => {
        return {
          id: result.id,
          firstName: result.firstName,
          lastName: result.lastName,
          identifier: result?.offenderIdentifier?.value ?? '',
          email: result.email,
          cellPhoneNumber: result.phoneNumber,
          whatsAppPhoneNumber: result.whatsAppPhoneNumber ?? '',
          updateProfileType: profileType,
          signUpInformation: result.signUpInformation,
          communicationEmails: result.communicationEmails,
          isArchived: result.isArchived,
          isLocked: result.isLocked,
          isVerified: result.isVerified,
          doNotContact: result.doNotContact,
          identifierType: result?.offenderIdentifier?.identifierType,
          isWhatsAppVerified: result.isWhatsAppVerified,
          roles: result.roles.map((role) => RoleEnum[role]),
          disabled: result.disabled,
          invalidEmail: result.invalidEmail,
        };
      },
    },
  );
};
